import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";

export interface RegisterState {
  register: {};
}

const initialState: RegisterState = {
  register: "",
};

export const registerSlice = createSlice({
  name: "register",
  initialState,
  reducers: {
    register: (state, { payload: payload }) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.register = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { register } = registerSlice.actions;

export default registerSlice.reducer;
